
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/golf/courses",
      function () {
        return require("private-next-pages/golf/courses/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/golf/courses"])
      });
    }
  